const resetFns = new Set<() => void>();

export function registerResetFn(fn: () => void) {
  resetFns.add(fn);
}

export function resetAllStores() {
  resetFns.forEach((fn) => fn());
}
